/** Keep in sync with server/points-config.js */
export const FREE_DRINK_POINTS = 50;
export const POINTS_PER_JOD_EARNED = 1;

export const POINTS_RULE_SUMMARY =
  'Earn 1 point per 1 JOD on drinks only. Redeem 50 points for 1 free coffee.';

function isWaterMenuItem(category?: string | null, name?: string | null): boolean {
  const categoryLower = String(category || '').toLowerCase();
  const nameLower = String(name || '').toLowerCase();
  return nameLower.includes('water') || categoryLower.includes('water');
}

/** Same drink vs food split loyalty points use. Water does not count. */
export function isQualifyingDrinkMenuItem(
  category?: string | null,
  name?: string | null
): boolean {
  const categoryLower = String(category || '').toLowerCase();
  if (isWaterMenuItem(category, name)) return false;
  return (
    categoryLower.includes('drink') ||
    categoryLower.includes('coffee') ||
    categoryLower.includes('tea') ||
    categoryLower.includes('juice') ||
    categoryLower.includes('smoothie') ||
    categoryLower.includes('espresso') ||
    categoryLower === 'coffee' ||
    categoryLower === 'tea'
  );
}

/** Sweets, pastries, and savory food. Drinks and water do not count. */
export function isQualifyingFoodMenuItem(
  category?: string | null,
  name?: string | null
): boolean {
  if (isWaterMenuItem(category, name)) return false;
  return !isQualifyingDrinkMenuItem(category, name);
}
